(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('AgentAccessInfo', AgentAccessInfo);

    AgentAccessInfo.$inject = ['$resource'];

    function AgentAccessInfo($resource) {
        var resourceUrl = 'api/agent-access-infos/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
